import React, { useEffect, useState } from "react";

export const DataTable = React.memo((props) => {
  const tableId = `datatableDefault${props.count ? props.count : 1}`;
  const [currentPage, setCurrentPage] = useState(1);

  // Function to initialize or reload DataTable
  const initializeDataTable = () => {
    const tableSelector = "#" + tableId;

    // Destroy previous DataTable instance if it exists
    if (window.$.fn.DataTable.isDataTable(tableSelector)) {
      window.$(tableSelector).DataTable().destroy();
    }

    // Initialize DataTable
    const table = window.$(tableSelector).DataTable({
      dom: "<'row mb-3'<'col col-lg-4'l><'col-sm-12 col-lg-8 text-end'<'d-flex data-table-resp justify-content-between'fB>>>t<'d-flex align-items-center'<'me-auto'i><'mb-0'p>>",
      responsive: true,
      buttons: [
        { extend: "print", className: "btn btn-default rounded me-2" },
        { extend: "csv", className: "btn btn-default rounded" },
      ],
      data: props.data || [],
      columns: props.headers || [],
      paging: true,
      pageLength: 10,
      stateSave: false, // Ensure it doesn't save previous page state
    });

    // Reset to Page 1
    table.page(0).draw(false);
    setCurrentPage(1);

    // Handle page change event
    table.on("page.dt", function () {
      const pageInfo = table.page.info();
      setCurrentPage(pageInfo.page + 1);
    });
  };

  // Reinitialize DataTable when data or headers change
  useEffect(() => {
    initializeDataTable();
  }, [props.data, props.headers]);

  // Handle button click events dynamically
  useEffect(() => {
    const handleDetailsClick = function () {
      const employeeId = window.$(this).data("emloyeeid");
      const index = window.$(this).attr("data-index");
      props.onDetails?.(employeeId, index);
    };

    const handleMarkAttendanceClick = function () {
      const employeeId = window.$(this).data("emloyeeid");
      const id = window.$(this).attr("data-id");
      props.onSelectSubmit?.(id, employeeId);
    };

    window.$(document).on("click", ".details", handleDetailsClick);
    window.$(document).on("click", ".mark-attendance", handleMarkAttendanceClick);

    return () => {
      window.$(document).off("click", ".details", handleDetailsClick);
      window.$(document).off("click", ".mark-attendance", handleMarkAttendanceClick);
    };
  }, [props.onDetails, props.onSelectSubmit]);

  // Handle parent functions (delete, update, image show)
  useEffect(() => {
    const deleteFun=function () {
      props.parentFun.onDelete(window.$(this).data("id"), window.$(this).data("index"));
    };
    const updateFun=function (event) {
      event.preventDefault();
      props.parentFun.onUpdate(window.$(this).data("id"), window.$(this).data("index"));
    }
    const updateImageFun=function () {
      props.parentFun.onUpdateImage(window.$(this).data("id"), window.$(this).data("index"));
    }
    if (props.parentFun) {
     
      window.$(document).on("click", ".delete", deleteFun);

      window.$(document).on("click", ".update", updateFun);

      window.$(document).on("click", ".update_image",updateImageFun);
    }

    if (props.showImage) {
      window.$(document).on("click", ".image-show", function () {
        props.showImage(window.$(this).attr("src"));
      });

      return () => {
        if(props.parentFun){
          window.$(document).off("click", ".delete", deleteFun);

          window.$(document).off("click", ".update", updateFun);
    
          window.$(document).off("click", ".update_image",updateImageFun);
        }
      };
    }
  }, [props.parentFun, props.showImage]);

  return (
    <>
      <table id={tableId} className="table table-responsive"></table>
    </>
  );
});